module.exports = __webpack_public_path__ + "img/thumb-savviform.c87ef21f.jpg";